// extracted by mini-css-extract-plugin
module.exports = {"root":"SliderList_root__QmCfM","right":"SliderList_right__y10jr"};